export const getCookie = (name = `__cf_bm`) => {
  const match = document.cookie.match(new RegExp("(^|; )" + name + "=([^;]+)"))
  return match ? match[2] : null
}

export const setCookie = (name = `__cf_bm`, value) => {
  const now = new Date()
  const time = now.getTime()
  const expireTime = time + 1000 * 60 * 60 * 24 * 365
  now.setTime(expireTime)
  document.cookie =
    name + "=" + value + "; expires=" + now + ";path=/; Secure; SameSite=Lax;"
}

export default {
  getCookie,
  setCookie,
}
